/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const GoodIcon = props => {
	const { color = '' } = props
	return (
		<svg
			data-name='icon bueno'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 42 43'
			width='1em'
			height='1em'
			{...props}
		>
			<g data-name='Grupo 7477'>
				<g data-name='Grupo 7476'>
					<path
						data-name='Trazado 13548'
						d='M21 42a21 21 0 1 1 21-21 21.024 21.024 0 0 1-21 21Zm0-40.528A19.528 19.528 0 1 0 40.527 21 19.55 19.55 0 0 0 21 1.472Z'
						fill={color}
					/>
				</g>
			</g>
			<path
				data-name='Trazado 13549'
				d='M28.71 25.224a.747.747 0 0 1 .718.951c-.017.06-1.785 5.99-8.116 5.99s-8.035-5.895-8.051-5.954a.747.747 0 1 1 1.439-.4 6.845 6.845 0 0 0 6.612 4.858 6.979 6.979 0 0 0 6.68-4.91.749.749 0 0 1 .718-.535Z'
				fill={color}
			/>
			<path
				data-name='Trazado 13550'
				d='M11.801 20.48h-.066c-3.887-.033-5.155-2.7-5.282-4.1a.746.746 0 0 1 1.486-.14 3.158 3.158 0 0 0 .584 1.386 3.813 3.813 0 0 0 3.224 1.36 3.456 3.456 0 0 0 3.775-3.14.747.747 0 0 1 1.489.115 4.993 4.993 0 0 1-5.21 4.519Z'
				fill={color}
			/>
			<path
				data-name='Trazado 13551'
				d='M29.496 20.479h-.062c-4.9-.041-5.1-4.3-5.1-4.339a.747.747 0 0 1 1.492-.055c.014.3.237 2.873 3.621 2.9h.052a3.542 3.542 0 0 0 3.808-3.155.747.747 0 0 1 1.486.146 5.039 5.039 0 0 1-5.297 4.503Z'
				fill={color}
			/>
		</svg>
	)
}

export default GoodIcon
